/**
 * Formats the results "place" cell: numeric places stay as-is;
 * known result_status codes use vue-i18n `enums.result_status.*` (Czech abbreviations in cs locale, API codes in en).
 */
export function formatResultPlace(place, t, te) {
  if (place === null || place === undefined || place === '') return ''
  if (typeof place === 'number' && Number.isFinite(place)) return String(place)
  const s = String(place).trim()
  if (s === '') return ''
  if (/^\d+$/.test(s)) return s
  const code = s.toUpperCase()
  const key = `enums.result_status.${code}`
  if (te(key)) return t(key)
  return s
}
